module.exports = __webpack_public_path__ + "img/onisvida-bpb.4abd746f.png";